import type { AiAppCenterModule } from '../types'

/**
 * 律师平台（撮合运营：律师准入 / 商机 / 订单 / 案件域）
 * 后端 system_module.name=lawyer；独立窗 /ai-Application-center/lawyer/*
 * 律所 ERP 见 lawyer-firm.ts，勿把 Track F 菜单挂回本模块
 */
export const lawyerModule: AiAppCenterModule = {
  key: 'lawyer',
  label: '律师平台',
  desc: '律师准入、商机撮合、订单分账、案件域（咨询/案件/要素/证据/文书/电子签署）一站式管理',
  path: '/lawyer',
  homePath: '/lawyer/case',
  menuPaths: ['/lawyer'],
  icon: 'ep:scale-to-original',
  color: '#722ed1',
  aliases: ['律师平台', '法律服务'],
  hiddenStandaloneMenuTitles: ['合同审核', '签署记录']
}